import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { DateTime } from "luxon";
import { Calendar } from "@hassanmojab/react-modern-calendar-datepicker";

import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";

import PJPContext from "pages/PJPView/pjp.context";
import { getMonthlyPlan, getVisitsDetails } from "_controllers/officer";

const CalendarItem = () => {
  const { planDate, setPlanDate, setPlan } = useContext(PJPContext);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [disabledDates, setDisabledDates] = useState();

  const { SAP_ID } = useParams();

  useEffect(() => {
    const today = DateTime.now();

    const startDate =
      today.day > 27
        ? today.plus({ months: 1 }).startOf("month")
        : today.startOf("month");

    const endDate = startDate.endOf("month");

    setStartDate({
      year: startDate.year,
      month: startDate.month,
      day: startDate.day,
    });
    setEndDate({
      year: endDate.year,
      month: endDate.month,
      day: endDate.day,
    });
  }, []);

  useEffect(async () => {
    // if (!planDate || !SAP_ID) return;

    const plan = await getVisitsDetails({
      SAP_ID,
      planDate,
      startDate,
      endDate,
    });

    setPlan(plan);
  }, [planDate]);

  useEffect(async () => {
    if (!SAP_ID || !startDate || !endDate) return;

    const response = await getMonthlyPlan({
      SAP_ID,
      from: startDate,
      to: endDate,
    });

    const data = response.data;

    let start = DateTime.fromFormat(
      `${startDate.year}-${startDate.month}-${startDate.day}`,
      "yyyy-MM-d"
    );

    let end = DateTime.fromFormat(
      `${endDate.year}-${endDate.month}-${endDate.day}`,
      "yyyy-MM-d"
    );

    const disabledDates = [];

    while (start <= end) {
      const planDates = data?.pjps?.map((pjp) =>
        DateTime.fromISO(pjp.planDate).startOf("day").toString()
      );

      if (!planDates.includes(start.toString())) disabledDates.push(start);

      start = start?.plus({ days: 1 });
    }

    setDisabledDates(
      disabledDates.map((date) => ({
        year: date.year,
        month: date.month,
        day: date.day,
      }))
    );
  }, [startDate, endDate]);

  return (
    <Calendar
      value={planDate}
      onChange={setPlanDate}
      inputPlaceholder="Select a Date"
      minimumDate={startDate}
      maximumDate={endDate}
      colorPrimary="#fdbc00"
      disabledDays={disabledDates}
    />
  );
};

export default CalendarItem;
